import React, { Component } from 'react'
import EmailForm from '../../forms/email/EmailForm'
import MediaCard from '../../cards/MediaCard'

export class Footer extends Component {


    render() {
        return (
            <footer className="footer">
                <EmailForm />
                <div className="media-card__footer-box">
                    <MediaCard />
                    <h4 className="h4 footer__copyright">&copy; Kevin Laird {new Date().getFullYear()}</h4>
                </div>
            </footer>
        )
    }
}

export default Footer
